import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.6_@babel+core@7.29.0_@playwright+test@1.56.1_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/destinations/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Code"] */ "/app/src/blocks/Code/Component.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/EmailObfuscator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LivePreviewListener"] */ "/app/src/components/LivePreviewListener/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DestinationHero"] */ "/app/src/heros/DestinationHero/index.tsx");
